import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';

import { RemoteAgentState } from './RemoteAgentStates';

export type RemoteAgentPresenceIconProps = Readonly<{
  status: RemoteAgentConnectionStatus;
  remoteAgentStates: { readonly [s in RemoteAgentConnectionStatus]: RemoteAgentState };
}>;

export function RemoteAgentPresenceIcon(props: RemoteAgentPresenceIconProps) {
  const { status: state, remoteAgentStates } = props;
  if (FeatureFlags.edgeMultiPoolEnabled) {
    return <img
      className={statusIconClass}
      title={remoteAgentStates[state].stateText}
      src={imgPath(remoteAgentStates[state].stateImage)}
      alt={''}
    />;
  }

  return <span
    className={remoteAgentStates[state].stateClass}
    title={remoteAgentStates[state].stateText}
  />;
}

export const statusIconClass = style({
  verticalAlign: 'text-bottom',
  marginRight: TabStyles.Spacing.DefaultSpace
});
